import React from 'react'

function Footer() {
    return (
        <div className='footer'>
            <div className='footer-items'>
                <a class="item" href="https://t.me/BASEREWARDOFFICIAL" target="_blank">TELEGRAM</a>
                <a class="item" href="https://www.facebook.com/basereward/" target="_blank">FACEBOOK</a>
                <a class="item" href="https://twitter.com/baserewardtoken?lang=en" target="_blank">TWITTER</a>
                <a class="item" href="https://bit.ly/3cHIKwe" target="_blank">PANCAKE SWAP BRT-BNB</a>
                <a class="item" href="#">GITHUB</a>
            </div>
        </div>
    )
}

export default Footer;
